import React from 'react'
import Link from 'components/Link'
import EmptyHeader from 'containers/EmptyHeader'
import ErrorMessage from 'components/ErrorMessage'
import styled from 'styled-components'
import { ReactComponent as Logo } from 'icons/logo.svg'
import { IsSignedIn } from 'containers/IsSignedIn'
import { IsEmbedded, NotEmbedded } from 'components/Embedding'
import { EmbeddedErrorPage } from 'modules/shares/components/EmbeddedErrorPage'
import { CenterContent } from 'containers/CenterContent'
import { routes } from 'constants/routes'

const StyledErrorMessage = styled(ErrorMessage)`
  flex: 1 0 auto;
  align-self: center;
`

interface RenderNotFoundStateProps {
  isSignedIn?: boolean
  title?: string
  additionalMessage?: React.ReactNode
}

export const RenderNotFoundState: React.FC<RenderNotFoundStateProps> = ({
  title = 'We cannot find the page you’re looking for.',
  additionalMessage,
  isSignedIn,
}) => (
  <StyledErrorMessage
    title={title}
    icon={() => <Logo width="46px" height="46px" />}>
    {additionalMessage}
    {isSignedIn ? (
      <Link to={routes.ENTRY.create({})}>Go to your documents overview</Link>
    ) : (
      <span>
        <Link to={routes.SIGN_IN.create({})}>Sign in to Sketch Cloud</Link> or{' '}
        <Link to={routes.SIGN_UP.create({})}>Create an account</Link>
      </span>
    )}
  </StyledErrorMessage>
)

interface NotFoundStateProps {
  title?: string
  additionalMessage?: React.ReactNode
}

export const NotFoundState: React.FC<NotFoundStateProps> = props => (
  <IsSignedIn>
    {(isSignedIn: boolean) => (
      <RenderNotFoundState
        title={props.title}
        additionalMessage={props.additionalMessage}
        isSignedIn={isSignedIn}
      />
    )}
  </IsSignedIn>
)

interface NotFoundViewProps {
  title?: string
  additionalMessage?: React.ReactNode
}

const NotFoundView: React.FC<NotFoundViewProps> = props => (
  <>
    <NotEmbedded>
      <CenterContent>
        <EmptyHeader />
        <NotFoundState
          title={props.title}
          additionalMessage={props.additionalMessage}
        />
      </CenterContent>
    </NotEmbedded>
    <IsEmbedded>
      <EmbeddedErrorPage for="unknown" />
    </IsEmbedded>
  </>
)

export default NotFoundView
